import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { parseTicketText, venueById } from "@anjabom/core";
export function TicketPaste({ initial = "", compact = false }: { initial?: string; compact?: boolean }) {
	const [text, setText] = useState(initial);
	const result = parseTicketText(text),
		venue = result.venueId ? venueById(result.venueId) : null;
	const params = new URLSearchParams();
	if (result.venueId) params.set("venue", result.venueId);
	if (result.spaceId) params.set("space", result.spaceId);
	if (result.sectionCode) params.set("section", result.sectionCode);
	if (result.rowLabel) params.set("row", result.rowLabel);
	if (result.seatNumber) params.set("number", String(result.seatNumber));
	return (
		<section className={`stack ticket-paste${compact ? " ticket-paste-compact" : ""}`}>
			<label className="field">
				예매 문자를 붙여 넣으면 좌석을 찾아요
				<textarea
					className="textarea"
					rows={compact ? 2 : 3}
					value={text}
					onChange={(e) => setText(e.target.value)}
					placeholder="블루스퀘어 우리은행홀 1층 17열 12번"
					maxLength={3000}
				/>
			</label>
			<p className="micro">문자 원문은 서버로 보내거나 보관하지 않아요.</p>
			{text ? (
				<>
					<p>
						{venue
							? `${venue.name} · ${result.sectionCode ?? "구역 확인 필요"} ${result.rowLabel ? `${result.rowLabel}열` : ""} ${result.seatNumber ? `${result.seatNumber}번` : ""}`
							: "공연장 이름을 찾지 못했어요. 장소부터 직접 골라 주세요."}
					</p>
					<Link className="button" to={`/start?${params}`}>
						채운 값 확인하고 좌석 찾기
					</Link>
				</>
			) : null}
		</section>
	);
}
export function ShareTargetPage() {
	const [params] = useSearchParams();
	return (
		<section className="page narrow stack-lg">
			<h1>공유받은 좌석을 확인해요</h1>
			<TicketPaste
				initial={[params.get("title"), params.get("text")]
					.filter(Boolean)
					.join(" ")}
			/>
		</section>
	);
}
